export class AccDocumentAttachmentParameterDto {
    fileId: number;
    fileBase64String: string;
    fileName: string;
}
